export const BASE_PATH = '/search';
